import styled from "@emotion/styled";
import Markdown, { Options } from "react-markdown";

const StyledMarkdown = styled.div`
    p {
        margin: 0;
    }
`;

type MprcMarkdownProps = Omit<Options, "className">;

export const MprcMarkdown: React.FC<MprcMarkdownProps> = (props) => {
  return (
    <StyledMarkdown>
      <Markdown {...props} />
    </StyledMarkdown>
  );
};
